import { put, call, take, fork, select } from 'redux-saga/effects';
import * as actions from 'actions/vessels/sales';
import mockSale from 'mocks/vessel/sales.json';
import * as actionTypes from 'constants/ActionTypes';
import api from 'services';
import { refNumber } from '../refNumber';
import { getUserMail } from '../common';

// eslint-disable-next-line require-yield
function* fillAndCreateVesselSales(clarified) {
    const items = [];

    clarified.forEach((item) => {
        if (item.vessel) {
            items.push({
                ...mockSale,
                vessel: item.vessel._id,
                vesselName: item.vessel.name,
                imoNumber: item.vessel.imoNumber,
                DWT: item.vessel.deadWeight.sDWT,
                BLT: item.vessel.blt,
            });
        } else {
            items.push(mockSale);
        }
    });

    return items;
}

export function* createVesselSales(response) {
    if (response.status === 200) {
        if (response.data.clarified && response.data.clarified.length > 0) {
            const vesselSales = yield call(fillAndCreateVesselSales, response.data.clarified);
            
            const userEmail = getUserMail(response.data);

            yield put({
                type: actionTypes.ADD_NOTIFICATION,
                notification: {
                    title: 'Created',
                    message: `The ${vesselSales.length} vessel sales created`,
                    level: 'success',
                    _id: new Date().getMilliseconds(),
                    autoDismiss: 4,
                },
            });

            yield put(actions.createVesselSales(vesselSales, { email: userEmail }));
        } else {
            yield put({
                type: actionTypes.ADD_NOTIFICATION,
                notification: {
                    title: 'Warning',
                    message: 'The vessel sales did\'t create',
                    level: 'warning',
                    _id: new Date().getMilliseconds(),
                    autoDismiss: 4,
                },
            });

            yield put(actions.resetVesselSales());
        }
    } else {
        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Warning',
                message: 'The vessel sales did\'t create',
                level: 'warning',
                _id: new Date().getMilliseconds(),
                autoDismiss: 4,
            },
        });

        yield put(actions.addVesselSale());
    }
}

function* postVesselSaleRequest(vesselId, vesselSale) {
    const response = yield call(api.postVesselSale, vesselId, vesselSale);

    if (response.status === 200) {
        yield put({
            type: actionTypes.POST_VESSEL_SALE.SUCCESS,
            data: response.data,
            vesselSale,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: `Success vessel sale - ${vesselSale.keyVesselSale + 1}`,
                level: 'success',
                _id: new Date().getMilliseconds(),
                autoDismiss: 10,
            },
        });

        yield call(refNumber, response.data);
        return response;
    }

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: `Error vessel sale - ${vesselSale.keyVesselSale + 1}`,
            message: response.errors[0].messages[0],
            level: 'error',
            _id: new Date().getMilliseconds(),
            autoDismiss: 10,
        },
    });

    yield put({
        type: actionTypes.POST_VESSEL_SALE.FAILURE,
        errors: response.errors,
        vesselSale,
    });

    return response;
}

function* getSalesVessel(filter) {
    const response = yield call(api.getVesselSales, filter);
    // todo response with pagination
    if (response.status === 200) {
        yield put({
            type: actionTypes.GET_VESSEL_SALES.SUCCESS,
            data: response,
        });

        return response;
    }

    yield put({
        type: actionTypes.GET_VESSEL_SALES.FAILURE,
        errors: response.errors,
    });

    return response;
}

export function* getSalesVesselWatch() {
    while (true) {
        const { filter } = yield take(actionTypes.GET_VESSEL_SALES.REQUEST);
        yield fork(getSalesVessel, filter);
    }
}

export function* postVesselSaleRequestWatch() {
    while (true) {
        const vesselSale = yield take(actionTypes.POST_VESSEL_SALE.REQUEST);
        yield fork(postVesselSaleRequest, vesselSale.vesselId, vesselSale.vesselSaleRequest);
    }
}

function* deleteVesselSale(saleId) {
    const response = yield call(api.deleteVesselSale, saleId);
    if (response.status === 200) {
        const store = yield select();

        yield put({
            type: actionTypes.DELETE_VESSEL_SALE.SUCCESS,
            saleId,
            email: store.user.user.email,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: response.data.messages[0],
                level: 'success',
                _id: saleId,
                autoDismiss: 2,
            },
        });

        return response;
    }

    yield put({
        type: actionTypes.DELETE_VESSEL_SALE.FAILURE,
        saleId,
        error: response.errors,
    });

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Error',
            message: response.errors[0].messages[0],
            level: 'error',
            _id: saleId,
            autoDismiss: 2,
        },
    });

    return response;
}

export function* watchDeleteVesselSale() {
    while (true) {
        const { saleId } = yield take(actionTypes.DELETE_VESSEL_SALE.REQUEST);
        yield fork(deleteVesselSale, saleId);
    }
}

export default [postVesselSaleRequestWatch, getSalesVesselWatch, watchDeleteVesselSale];



// WEBPACK FOOTER //
// ./app/sagas/vessels/sales.js